/**
 * Floating action button to open artworks panel on mobile
 */

import { cn } from '@frameit/ui';
import { useProjectStore } from '../../stores/projectStore';

export function FloatingArtworkButton() {
  const mobileArtworksOpen = useProjectStore((s) => s.mobileArtworksOpen);
  const setMobileArtworksOpen = useProjectStore((s) => s.setMobileArtworksOpen);
  const project = useProjectStore((s) => s.project);

  const artworkCount = project?.framedArtworks?.length ?? 0;

  return (
    <button
      onClick={() => setMobileArtworksOpen(!mobileArtworksOpen)}
      className={cn(
        'fixed bottom-20 right-4 z-30',
        'flex h-14 w-14 items-center justify-center',
        'rounded-full bg-primary text-primary-foreground shadow-lg',
        'active:scale-95 transition-transform',
        'mb-safe-bottom'
      )}
      aria-label={mobileArtworksOpen ? 'Close artworks' : 'Open artworks'}
    >
      {mobileArtworksOpen ? (
        <svg
          className="h-6 w-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      ) : (
        <>
          <svg
            className="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          {artworkCount > 0 && (
            <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-destructive text-xs font-medium text-destructive-foreground">
              {artworkCount}
            </span>
          )}
        </>
      )}
    </button>
  );
}
